import { AppSettings } from '../../interfaces/app-settings.interface';

export const DEFAULT_SETTINGS: Readonly<AppSettings> = {
  language: {
    key: '5s_lang',
    displayName: 'SETTINGS-PAGE.DEFAULT-SETTING.LANGUAGE',
    icon: 'globe-regular.svg',
    defaultValue: { value: 'en', label: 'SETTINGS-PAGE.DEFAULT-SETTING.ENGLISH' },
    selectedValue: { value: 'en', label: 'SETTINGS-PAGE.DEFAULT-SETTING.ENGLISH' },
    availableValues: [
      { value: 'en', label: 'SETTINGS-PAGE.DEFAULT-SETTING.ENGLISH' },
      { value: 'hu', label: 'SETTINGS-PAGE.DEFAULT-SETTING.HUNGARIAN' }
    ]
  },
  fontSize: {
    key: '5s_font_size',
    displayName: 'SETTINGS-PAGE.DEFAULT-SETTING.FONT-SIZE',
    icon: 'text-as-regular.svg',
    defaultValue: { value: 'large', label: 'SETTINGS-PAGE.DEFAULT-SETTING.SIZE-LARGE' },
    selectedValue: { value: 'large', label: 'SETTINGS-PAGE.DEFAULT-SETTING.SIZE-LARGE' },
    availableValues: [
      { value: 'small', label: 'SETTINGS-PAGE.DEFAULT-SETTING.SIZE-SMALL' },
      { value: 'medium', label: 'SETTINGS-PAGE.DEFAULT-SETTING.SIZE-MEDIUM' },
      { value: 'large', label: 'SETTINGS-PAGE.DEFAULT-SETTING.SIZE-LARGE' }
    ]
  }
};
